export const SHOW_NEW_INVESTMENTS_FEATURE = true
